import { type Generator, type PaginatedGenerator } from './types.ts';

export function fromFunction<T>(generator: Generator<T>): AsyncIterable<T> {
  return {
    [Symbol.asyncIterator]: () => {
      return {
        async next(): Promise<IteratorResult<T>> {
          return { value: await generator(), done: false };
        },
      };
    },
  };
}

export function fromPaginatedFunction<T>(
  start: number,
  size: number,
  fetch: PaginatedGenerator<T>,
): AsyncIterable<T> {
  let i = start;

  return fromFunction(() => {
    const result = fetch(i, size);
    i += size;
    return result;
  });
}

export async function* fromIterable<T>(
  generator: Iterable<T | Promise<T>>,
): AsyncIterable<T> {
  for (const value of generator) {
    yield await value;
  }
}

export async function* fromReadable(readable: ReadableStream<Uint8Array>) {
  const reader = readable.getReader();

  try {
    const decoder = new TextDecoder();

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      yield decoder.decode(value, { stream: true });
    }
  } finally {
    reader.releaseLock();
  }
}
